export type MedicinePublicationKind = "ARTICLE" | "THESIS";

export type MedicinePublication = {
  id: number;
  kind: MedicinePublicationKind;
  title: string;
  authors: string;
  /** Журнал, год, страницы и DOI одной строкой. У тезисов обычно пусто. */
  source?: string | null;
  /** Пусто — карточка на сайте не кликабельна. */
  linkUrl?: string | null;
  publishedYear?: number | null;
  ord?: number;
  isActive: boolean;
};

export type MedicinePublicationsResponse = {
  publications: MedicinePublication[];
};

export type MedicinePublicationFormValues = {
  id?: number;
  title: string;
  authors: string;
  source?: string | null;
  linkUrl?: string | null;
  publishedYear?: number | null;
  isActive: boolean;
};

/** Подписи блока: один компонент обслуживает и статьи, и тезисы. */
export type PublicationKindLabels = {
  blockTitle: string;
  addButton: string;
  createTitle: string;
  editTitle: string;
  emptyText: string;
  removeConfirm: string;
  /** У тезисов источник почти всегда пуст — подсказываем в форме. */
  sourceHint: string;
};

export const PUBLICATION_LABELS: Record<
  MedicinePublicationKind,
  PublicationKindLabels
> = {
  ARTICLE: {
    blockTitle: "Статьи",
    addButton: "Добавить статью",
    createTitle: "Добавить статью",
    editTitle: "Редактировать статью",
    emptyText: "Статьи отсутствуют",
    removeConfirm: "Удалить статью?",
    sourceHint: "Журнал, год, том, страницы и DOI одной строкой",
  },
  THESIS: {
    blockTitle: "Тезисы",
    addButton: "Добавить тезис",
    createTitle: "Добавить тезис",
    editTitle: "Редактировать тезис",
    emptyText: "Тезисы отсутствуют",
    removeConfirm: "Удалить тезис?",
    sourceHint: "У тезисов обычно не заполняется",
  },
};
